module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Cart1-6a3ca92466ba7198c5f6251b5d69dcb4.svg";